GameView   = require "views/base/game"
{ DraggyView } = require("views/components/draggy")
Prefix     = require("lib/prefix")

HALFTURN = Math.PI / 2
QUARTURN = Math.PI / 4

class FindAWordView extends GameView
  template: require("./template")
  fitTextOnResize: false
  fitTextOnRender: false

  orientations: [
    "verticalUp"
    "diagonalUp"
    "horizontal"
    "diagonal"
    "vertical"
    "diagonalBack"
    "horizontalBack"
    "diagonalUpBack"
  ]

  events: ->
    "iostap .btn-done": "endGame"

  serialize: ->
    data = super
    words   = _.uniq (w?.replace(/\s/g, "").toUpperCase() or "" for w in data.words)
    letters = _.uniq words.join("")

    @grid    ?= window.wordfind.newPuzzle words, { letters }
    @solution = window.wordfind.solve(@grid, words).found
    data.grid = @grid
    data

  beforeShow: ->
    @setEl @findAll(".grid-highlight"), "highlight"

    el = @findOne(".grid")
    el.style.width  = ""

    fontSize = parseFloat(window.getComputedStyle(@el).fontSize)

    # Ensure small screens and resizes don't impact Find-A-Word
    gridSizeEm = Math.min(el.offsetWidth / fontSize, 22)
    colSizeEm = gridSizeEm / @grid.length
    colSizePx = colSizeEm * fontSize

    @size = colSizePx

    el.style.width      = "#{gridSizeEm}em"
    el.style.height     = "#{gridSizeEm}em"
    el.style.lineHeight = "#{colSizeEm * 1.1}em"

    for el in @getEl("highlight")
      el.style[Prefix "transformOrigin"] = "#{colSizeEm / 2}em"
      { x, y, t } = el.dataset
      if x? and y? and t?
        @transform el,
          x: "#{x * colSizeEm}em"
          y: "#{y * colSizeEm}em"
          rotate: "#{t * QUARTURN - HALFTURN}rad"

  show: ->
    super

    @draggy = new DraggyView
      el: @findOne(".grid")
      isParent: true

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop
    @listenTo this, "resize", @onResize

    @onResize()

    @enterGame()

  refresh: ->
    delete @grid
    super
    @serialize()
    @beforeShow()

  hide: ->
    delete @grid

  onResize: (e) ->
    unless e?.width or @currentState?.refresh
      @el.classList.remove("active")

    @beforeShow()

    @fitText =>
      colSizePx = Math.round(@findOne(".grid").offsetWidth / @grid.length)
      @size = colSizePx

      window.setTimeout (=>
        @el.classList.add("active")
      ), 300

  onDrag: (draggy, isInitial) ->
    el = @getEl("highlight").item(@solution.length)
    el.classList.add("active")

    if isInitial
      { x, y } = draggy
      @line =
        theta: 0
        start:
          x: Math.floor(x / @size)
          y: Math.floor(y / @size)

      @transform el,
        x: @line.start.x * @size
        y: @line.start.y * @size

      el.offsetWidth
      @setState true, "dragging"

    else
      { x, y } = draggy
      gs = @grid.length - 1
      gx = @line.start.x
      gy = @line.start.y
      x -= (gx + 0.5) * @size
      y -= (gy + 0.5) * @size
      t  = Math.ceil((draggy.toAngle(x, y) - HALFTURN) / QUARTURN + HALFTURN)
      gw = if t % 2 is 0 then 1 else Math.SQRT2

      baseRotation = @line.theta - (@line.theta % 8)
      rotationDiff = (@line.theta % 8) - t

      if rotationDiff < -5
        baseRotation -= 8
      else if rotationDiff is 8
        baseRotation += 8

      max = @getMaxLength(gx, gy, t)

      len = Math.round (
        if t % 2 is 0
          Math.max(Math.abs(x), Math.abs(y))
        else
          Math.sqrt(x * x + y * y)
       ) / (gw * @size)

      @line.length = Math.max(Math.min(len, max) + 1, 1)
      @line.theta  = (baseRotation or 0) + t
      @line.orientation = @orientations[t % 8]

      @transform el,
        x: @line.start.x * @size
        y: @line.start.y * @size
        rotate: "#{@line.theta * QUARTURN - HALFTURN}rad"

      el.dataset.x = @line.start.x
      el.dataset.y = @line.start.y
      el.dataset.t = @line.theta
      el.style.width = "#{(1 + (@line.length - 1) * gw) / (gs + 1) * 100}%"

  onDrop: (draggy, isReset) ->
    el = @getEl("highlight").item(@solution.length)
    el.classList.remove "active"

    letters = @getSelection(@line)
    word    = letters.reduce ((m, e) -> m + e.dataset.letter), ""
    answer  = _.find @solution, { word }

    if answer
      @solution = _.without @solution, answer
      el.classList.add "complete"
      letter.classList.add("complete") for letter in letters

    else
      @transform el,
        x: @line.start.x * @size
        y: @line.start.y * @size
        rotate: "#{@line.theta * QUARTURN - HALFTURN}rad"
        scale: 1.2

      window.setTimeout =>
        el.style.width = ""
        @setState false, "dragging"
      , 300

    @setState "touched"

  getSelection: (line) ->
    { start: {x, y}, orientation, length } = line

    for i in [0...length]
      p = window.wordfind.orientations[orientation](x, y, i)
      r = Math.floor(p.y * @grid.length) / @grid.length
      c = p.x % @grid.length
      @draggy.el.children[r]?.children[c]

  getOrientation: (theta) ->
    @orientations[theta % 8]

  getMaxLength: (x, y, theta) ->
    size = @grid.length - 1
    switch theta % 8
      when 1 then Math.min(size - x, y)
      when 2 then size - x
      when 3 then Math.min(size - x, size - y)
      when 4 then size - y
      when 5 then Math.min(x, size - y)
      when 6 then x
      when 7 then Math.min(x, y)
      else y

  isCorrect: ->
    @solution.length is 0

  showAnswer: ->
    for {x, y, overlap, orientation}, i in @solution
      letters = @getSelection({ start: { x, y }, length: overlap, orientation })
      el = @getEl("highlight").item(i)

      t  = @orientations.indexOf(orientation)
      gw = if t % 2 is 0 then 1 else Math.SQRT2

      @transform el,
        x: x * @size
        y: y * @size
        rotate: "#{t * QUARTURN - HALFTURN}rad"
      el.offsetWidth
      el.classList.add("incorrect")
      el.style.width = "#{gw * overlap / @grid.length * 100}%"

  endGame: ->
    super
    @submit()

module.exports = FindAWordView
